/**
 * POST /app-api/customer/gas-survey — 寫入問卷並觸發 lpg-predict 單客冷啟動預測。
 */
import api from "@services/axios/apiManager";
import type { GasSurveyRecord } from "@screen/Survey/surveyStorage";

export interface SubmitGasSurveyResponse {
  survey_id: string;
  survey_completed_at: string;
  prediction_source: "survey";
  run_date: string;
  home_gas_status?: Record<string, unknown> | null;
  prediction_pending?: boolean;
  predict_error?: string | null;
}

export async function postGasSurvey(args: {
  token: string;
  xContext: string;
  record: GasSurveyRecord;
  customerAddressId?: number | null;
}): Promise<SubmitGasSurveyResponse> {
  const { token, xContext, record, customerAddressId } = args;
  const res = await api.post(
    "/app-api/customer/gas-survey",
    {
      customer_address_id: customerAddressId ?? undefined,
      survey_days: record.survey_days,
      cylinder_kg: record.cylinder_kg,
      observed_interval_days: record.observed_interval_days,
      last_order_ago: record.last_order_ago ?? null,
      last_order_ago_days: record.last_order_ago_days ?? null,
      household_size: record.household_size ?? null,
      usage_types: record.usage_types ?? null,
      has_spare_cylinder: record.has_spare_cylinder ?? null,
    },
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "X-Context": xContext,
      },
    },
  );
  return res.data.data as SubmitGasSurveyResponse;
}
